<template>
  <div class="index-wrap pt10">
    <el-card class="box-card user-info-card">
      <div class="user-info flex">
        <!-- <img src="/img/user.png" alt=""> -->
        <div>
          {{ $store.state.userInfo.userName }}
        </div>
      </div>
      <div class="mt10">
        今天是{{ dateInfo }}
      </div>
    </el-card>

    <el-card class="box-card mt20">
      <div slot="header" class="clearfix">
        <span>技术需求</span>
      </div>
    </el-card>
  </div>
</template>

<script>
export default{
  name:'index',
  data(){
    return{
      dateInfo:''
    }
  },
  created(){
    let myDate = new Date()
    this.dateInfo = myDate.getFullYear()+'-'+myDate.getMonth()+'-'+myDate.getDate()+' 星期'+myDate.getDay()
  }
}
</script>

<style>
.user-info{
  align-items: center;
  border-bottom:3px solid #999;
}
.user-info-card .user-info img{
  width:80px;
  height:80px;
  border-radius:80px;
}
.index-wrap .el-card.is-always-shadow, .el-card.is-hover-shadow:focus, .el-card.is-hover-shadow:hover{ box-shadow: none; }
</style>
